import IconButton from '@material-ui/core/IconButton';
import Refresh from '@material-ui/icons/Refresh';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import SelectableField from '../forms/Fields/SelectableInput/SelectableField.jsx';
import MDButton from '../MDButton/MDButton.jsx';

@connect(state => ({}))
@reduxForm({ form: 'MksRelationsMatrixSearchForm' })
class MksRelationsMatrixHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cylindersOptions: [],
      keysOptions: [],
    };
  }

  componentDidMount() {
    this.updateCylindersOptions();
    this.updateKeysOptions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cylinders !== this.props.cylinders) {
      this.updateCylindersOptions();
    }
    if (prevProps.keys !== this.props.keys) {
      this.updateKeysOptions();
    }
  }

  updateCylindersOptions() {
    const { cylinders } = this.props;
    if (!cylinders) return;
    
    const options = _.map(cylinders, cylinder => ({
      value: cylinder.id,
      label: `${cylinder.doorName || '---'} (${cylinder.marking || '---'})`,
    }));
    
    this.setState({ cylindersOptions: _.sortBy(options, 'label') });
  }

  updateKeysOptions() {
    const { keys } = this.props;
    if (!keys) return;
    
    const options = _.map(keys, key => ({
      value: key.id,
      label: `${key.keyFunction || '---'} - ${key.designation || '---'}`,
    }));
    
    this.setState({ keysOptions: _.sortBy(options, 'label') });
  }

  onSelectCylinders(selectedCylinders) {
    const { onSelectCylinders } = this.props;
    if (onSelectCylinders) {
      onSelectCylinders(selectedCylinders);
    }
  }

  onSelectKeys(selectedKeys) {
    const { onSelectKeys } = this.props;
    if (onSelectKeys) {
      onSelectKeys(selectedKeys);
    }
  }

  onSearchReset() {
    const { dispatch, onSearchReset } = this.props;
    dispatch(reset('MksRelationsMatrixSearchForm'));
    if (onSearchReset) {
      onSearchReset();
    }
  }

  render() {
    const {
      themeName,
      onRefresh,
      entitiesNumberSection,
      totalRelations,
    } = this.props;

    const { cylindersOptions, keysOptions } = this.state;

    const themeClass = `list-view-header bg-${themeName}-theme`;
    
    return (
      <div className={themeClass} style={{ width: '100%' }}>
        <div style={{ minHeight: 70, padding: 0, display: 'flex', marginLeft: 0, alignItems: 'center' }}>
          {entitiesNumberSection}
          
          <Field
            name="selectedCylinders"
            component={SelectableField}
            multi
            options={cylindersOptions}
            placeholder={<Entity entity="selectCylinders" />}
            containerstyle={{ minWidth: 300, marginRight: 10 }}
            onSelect={(selectedCylinders) => this.onSelectCylinders(selectedCylinders)}
          />

          <Field
            name="selectedKeys"
            component={SelectableField}
            multi
            options={keysOptions}
            placeholder={<Entity entity="selectKeys" />}
            containerstyle={{ minWidth: 300, marginRight: 10 }}
            onSelect={(selectedKeys) => this.onSelectKeys(selectedKeys)}
          />

          <MDButton
            backgroundColor="#F44336"
            containerStyle={{ margin: 0, marginLeft: 10, marginTop: 0 }}
            title={<Entity entity="reset" />}
            onClick={() => this.onSearchReset()}
          />
        </div>
      </div>
    );
  }
}

export default MksRelationsMatrixHeader;

